// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3SUEd","filesListContainer":"PosDisputesFiles_filesListContainer__36vOa","filesButton":"PosDisputesFiles_filesButton__1lE8d"};